/**
 * @generated SignedSource<<67107754bf9aea1e6c4d2c9115306270>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteShopifyRecurringChargesTaskInput = {
  salesChannelID?: string | null;
};
export type salesChannelGenerateDeleteShopifyRecurringChargesTaskMutation$variables = {
  input: DeleteShopifyRecurringChargesTaskInput;
};
export type salesChannelGenerateDeleteShopifyRecurringChargesTaskMutation$data = {
  readonly generateDeleteShopifyRecurringChargesTask: {
    readonly taskID: number;
  } | null;
};
export type salesChannelGenerateDeleteShopifyRecurringChargesTaskMutation = {
  response: salesChannelGenerateDeleteShopifyRecurringChargesTaskMutation$data;
  variables: salesChannelGenerateDeleteShopifyRecurringChargesTaskMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ProductSwitcherTaskOutput",
    "kind": "LinkedField",
    "name": "generateDeleteShopifyRecurringChargesTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelGenerateDeleteShopifyRecurringChargesTaskMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "salesChannelGenerateDeleteShopifyRecurringChargesTaskMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "08b6ca2edc60b23fbc8bd6c851bbb6bd",
    "id": null,
    "metadata": {},
    "name": "salesChannelGenerateDeleteShopifyRecurringChargesTaskMutation",
    "operationKind": "mutation",
    "text": "mutation salesChannelGenerateDeleteShopifyRecurringChargesTaskMutation(\n  $input: DeleteShopifyRecurringChargesTaskInput!\n) {\n  generateDeleteShopifyRecurringChargesTask(input: $input) {\n    taskID\n  }\n}\n"
  }
};
})();

(node as any).hash = "d0f3ba4b51bf624f4df37255756edf59";

export default node;
